import { CRUDApiService } from "./CRUDApiService";

export class FragranceApiService extends CRUDApiService {
  constructor() {
    super('fragrances');
  }
}
